module.exports = __webpack_public_path__ + "static/media/vray_logo_white.218bb5b1.svg";